export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_12.33a40286.jpg";